"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.estimateGasLimitAndStorage = void 0;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var shared_1 = require("../../../bridge/shared");
var scanAccounts_1 = require("../../../libcore/scanAccounts");
var getAccountNetworkInfo_1 = require("../../../libcore/getAccountNetworkInfo");
var syncAccount_1 = require("../../../libcore/syncAccount");
var getFeesForTransaction_1 = require("../../../libcore/getFeesForTransaction");
var libcore_broadcast_1 = __importDefault(require("../libcore-broadcast"));
var libcore_signOperation_1 = __importDefault(require("../libcore-signOperation"));
var cache_1 = require("../../../cache");
var account_1 = require("../../../account");
var access_1 = require("../../../libcore/access");
var buildBigNumber_1 = require("../../../libcore/buildBigNumber");
var getCoreAccount_1 = require("../../../libcore/getCoreAccount");
var bakers_1 = require("../bakers");
var env_1 = require("../../../env");
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
exports.estimateGasLimitAndStorage = (0, cache_1.makeLRUCache)(function (account, addr) {
    return (0, access_1.withLibcore)(function (core) { return __awaiter(void 0, void 0, void 0, function () {
        var coreAccount, tezosLikeAccount, gasLimit, _a, storage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, getCoreAccount_1.getCoreAccount)(core, account)];
                case 1:
                    coreAccount = (_b.sent()).coreAccount;
                    return [4 /*yield*/, coreAccount.asTezosLikeAccount()];
                case 2:
                    tezosLikeAccount = _b.sent();
                    _a = buildBigNumber_1.libcoreBigIntToBigNumber;
                    return [4 /*yield*/, tezosLikeAccount.getEstimatedGasLimit(addr)];
                case 3: return [4 /*yield*/, _a.apply(void 0, [_b.sent()])];
                case 4:
                    gasLimit = _b.sent();
                    storage = new bignumber_js_1.BigNumber(257);
                    /*
              const storage = await libcoreBigIntToBigNumber(
                await tezosLikeAccount.getStorage(addr)
              );
              */
                    return [2 /*return*/, {
                            gasLimit: gasLimit,
                            storage: storage
                        }];
            }
        });
    }); });
}, function (a, addr) { return a.id + "|" + addr; });
var calculateFees = (0, cache_1.makeLRUCache)(function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, (0, getFeesForTransaction_1.getFeesForTransaction)({
                account: a,
                transaction: t
            })];
    });
}); }, function (a, t) {
    return "".concat(a.id, "_").concat(t.amount.toString(), "_").concat(t.recipient, "_").concat(t.gasLimit ? t.gasLimit.toString() : "", "_").concat(t.fees ? t.fees.toString() : "", "_").concat(t.storageLimit ? t.storageLimit.toString() : "", "_").concat(String(t.useAllAmount), "_").concat(String(t.subAccountId));
});
var createTransaction = function () { return ({
    family: "tezos",
    mode: "send",
    amount: new bignumber_js_1.BigNumber(0),
    fees: null,
    gasLimit: null,
    storageLimit: null,
    recipient: "",
    networkInfo: null,
    useAllAmount: false,
    taquitoError: null,
    estimatedFees: null
}); };
var updateTransaction = function (t, patch) { return (__assign(__assign({}, t), patch)); };
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, subAcc, account, _a, recipientError, recipientWarning, estimatedFees, amount, totalSpent, thresholdWarning;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                errors = {};
                warnings = {};
                subAcc = !t.subAccountId
                    ? null
                    : a.subAccounts && a.subAccounts.find(function (ta) { return ta.id === t.subAccountId; });
                (0, invariant_1["default"])(t.mode === "send" || !subAcc, "delegation features not supported for sub accounts");
                account = subAcc || a;
                if (!(t.mode !== "undelegate")) return [3 /*break*/, 3];
                if (!(account.freshAddress === t.recipient)) return [3 /*break*/, 1];
                errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, (0, shared_1.validateRecipient)(a.currency, t.recipient)];
            case 2:
                _a = _b.sent(), recipientError = _a.recipientError, recipientWarning = _a.recipientWarning;
                if (recipientError) {
                    errors.recipient = recipientError;
                }
                if (recipientWarning) {
                    warnings.recipient = recipientWarning;
                }
                _b.label = 3;
            case 3:
                if (!(0, env_1.getEnv)("LEGACY_KT_SUPPORT_TO_YOUR_OWN_RISK") &&
                    t.recipient.startsWith("KT") &&
                    !errors.recipient) {
                    errors.recipient = new errors_1.NotSupportedLegacyAddress();
                }
                estimatedFees = new bignumber_js_1.BigNumber(0);
                amount = t.amount;
                if (!!t.fees) return [3 /*break*/, 4];
                errors.fees = new errors_1.FeeNotLoaded();
                return [3 /*break*/, 6];
            case 4:
                if (!!errors.recipient) return [3 /*break*/, 6];
                return [4 /*yield*/, calculateFees(a, t).then(function (res) {
                        estimatedFees = res.estimatedFees;
                        amount = res.value;
                    }, function (error) {
                        if (error.name === "NotEnoughBalance") {
                            errors.amount = error;
                        }
                        else {
                            throw error;
                        }
                    })];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6:
                if (!errors.amount && subAcc && estimatedFees.gt(a.balance)) {
                    errors.amount = new errors_1.NotEnoughBalanceInParentAccount();
                }
                totalSpent = !t.useAllAmount
                    ? t.amount.plus(estimatedFees)
                    : account.balance;
                if (!errors.recipient &&
                    !errors.amount &&
                    (amount.lt(0) || totalSpent.gt(account.balance))) {
                    errors.amount = new errors_1.NotEnoughBalance();
                    totalSpent = new bignumber_js_1.BigNumber(0);
                    amount = new bignumber_js_1.BigNumber(0);
                }
                if (t.mode === "send") {
                    if (!errors.amount && amount.eq(0)) {
                        errors.amount = new errors_1.AmountRequired();
                    }
                    else if (amount.gt(0) && estimatedFees.times(10).gt(amount)) {
                        warnings.feeTooHigh = new errors_1.FeeTooHigh();
                    }
                    thresholdWarning = 0.5 * Math.pow(10, a.currency.units[0].magnitude);
                    if (!subAcc &&
                        !errors.amount &&
                        account.balance.minus(totalSpent).lt(thresholdWarning)) {
                        if ((0, bakers_1.isAccountDelegating)(account)) {
                            warnings.amount = new errors_1.RecommendUndelegation();
                        }
                        else if ((a.subAccounts || []).some(account_1.isAccountBalanceSignificant)) {
                            warnings.amount = new errors_1.RecommendSubAccountsToEmpty();
                        }
                    }
                }
                else {
                    // delegation case, we remap NotEnoughBalance to a more precise error
                    if (errors.amount instanceof errors_1.NotEnoughBalance) {
                        errors.amount = new errors_1.NotEnoughBalanceToDelegate();
                    }
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount,
                        totalSpent: totalSpent
                    })];
        }
    });
}); };
var prepareTransaction = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var networkInfo, ni, gasLimit, storageLimit, recipientError, _a, r, fees;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                networkInfo = t.networkInfo;
                if (!!networkInfo) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, getAccountNetworkInfo_1.getAccountNetworkInfo)(a)];
            case 1:
                ni = _b.sent();
                (0, invariant_1["default"])(ni.family === "tezos", "tezos networkInfo expected");
                networkInfo = ni;
                _b.label = 2;
            case 2:
                gasLimit = t.gasLimit;
                storageLimit = t.storageLimit;
                if (!(!gasLimit || !storageLimit)) return [3 /*break*/, 7];
                if (!(t.mode === "undelegate")) return [3 /*break*/, 3];
                _a = { recipientError: undefined };
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, shared_1.validateRecipient)(a.currency, t.recipient)];
            case 4:
                _a = _b.sent();
                _b.label = 5;
            case 5:
                recipientError = (_a).recipientError;
                if (!!recipientError) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, exports.estimateGasLimitAndStorage)(a, t.recipient)];
            case 6:
                r = _b.sent();
                gasLimit = r.gasLimit;
                storageLimit = r.storage;
                _b.label = 7;
            case 7:
                fees = t.fees || networkInfo.fees;
                if (t.networkInfo !== networkInfo ||
                    t.gasLimit !== gasLimit ||
                    t.storageLimit !== storageLimit ||
                    t.fees !== fees) {
                    return [2 /*return*/, __assign(__assign({}, t), { networkInfo: networkInfo, storageLimit: storageLimit, gasLimit: gasLimit, fees: fees })];
                }
                return [2 /*return*/, t];
        }
    });
}); };
var estimateMaxSpendable = function (_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        var mainAccount, t, s;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
                    return [4 /*yield*/, prepareTransaction(mainAccount, __assign(__assign(__assign(__assign({}, createTransaction()), { subAccountId: account.type === "Account" ? null : account.id }), transaction), { 
                            // this seed is empty (worse case scenario is to send to new). addr from: 1. eyebrow 2. odor 3. rice 4. attack 5. loyal 6. tray 7. letter 8. harbor 9. resemble 10. sphere 11. system 12. forward 13. onion 14. buffalo 15. crumble
                            recipient: (transaction === null || transaction === void 0 ? void 0 : transaction.recipient) || "tz1VJitLYB31fEC82efFkLRU4AQUH9QgH3q6", useAllAmount: true }))];
                case 1:
                    t = _b.sent();
                    return [4 /*yield*/, getTransactionStatus(mainAccount, t)];
                case 2:
                    s = _b.sent();
                    return [2 /*return*/, s.amount];
            }
        });
    });
};
var preload = function () { return __awaiter(void 0, void 0, void 0, function () {
    var bakers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, bakers_1.fetchAllBakers)()];
            case 1:
                bakers = _a.sent();
                return [2 /*return*/, {
                        bakers: bakers
                    }];
        }
    });
}); };
var hydrate = function (data) {
    if (!data || typeof data !== "object")
        return;
    var bakers = data.bakers;
    if (!bakers || typeof bakers !== "object" || !Array.isArray(bakers))
        return;
    (0, bakers_1.hydrateBakers)(bakers);
};
var currencyBridge = {
    preload: preload,
    hydrate: hydrate,
    scanAccounts: scanAccounts_1.scanAccounts
};
var accountBridge = {
    createTransaction: createTransaction,
    updateTransaction: updateTransaction,
    prepareTransaction: prepareTransaction,
    getTransactionStatus: getTransactionStatus,
    estimateMaxSpendable: estimateMaxSpendable,
    sync: syncAccount_1.sync,
    receive: receive,
    signOperation: libcore_signOperation_1["default"],
    broadcast: libcore_broadcast_1["default"]
};
exports["default"] = {
    currencyBridge: currencyBridge,
    accountBridge: accountBridge
};
//# sourceMappingURL=libcore.js.map